export default function Mandala({ className = "", petals = 18, inner = 12, opacity = 1 }) {
    const ring = (n, ry, rx, o) =>
        Array.from({ length: n }, (_, i) => (
            <ellipse
                key={`${n}-${i}`}
                cx="300"
                cy={300 - ry}
                rx={rx}
                ry={ry}
                transform={`rotate(${(360 / n) * i} 300 300)`}
                stroke="#D4A017"
                strokeWidth="1"
                fill="none"
                opacity={o}
            />
        ));
    return (
        <svg viewBox="0 0 600 600" className={className} style={{ opacity }} aria-hidden="true">
            <circle cx="300" cy="300" r="292" stroke="#D4A017" strokeWidth="1" fill="none" opacity="0.45" strokeDasharray="3 9" />
            <circle cx="300" cy="300" r="248" stroke="#D4A017" strokeWidth="1" fill="none" opacity="0.6" />
            {ring(petals, 140, 26, 0.5)}
            <circle cx="300" cy="300" r="122" stroke="#D4A017" strokeWidth="1" fill="none" opacity="0.55" />
            {ring(inner, 88, 15, 0.4)}
            <circle cx="300" cy="300" r="42" stroke="#E88916" strokeWidth="1" fill="none" opacity="0.55" />
            <circle cx="300" cy="300" r="7" fill="#F5C542" opacity="0.7" />
        </svg>
    );
}
